baseApp.service('SocketUIService',['$rootScope' ,'UserContextService', function($rootScope, UserContextService) {
    return {
        openSocketUI: function (socketId, accountId) {
            if(UserContextService.isEditor()) {
                store.fetch({
                    method: 'GET',
                    url: 'getRemoteComponentProxyUrl',
                    queryParams: {
                        accountId: accountId,
                        component: 'SOCKET_UI',
                        socketId: socketId
                    },
                    success: function (serverResponse) {
                        if(serverResponse.status && serverResponse.status !== 'ERROR') {
                            window.open(window.location.origin + serverResponse.data.url, '_blank');
                        }
                        else {
                            $rootScope.handleServerResponse(serverResponse,"");
                        }
                    }
                });
            }
            else {
                $rootScope.showNotification("error", "Only admins with editor permissions can open the Socket WebUI from the Cato Management Application", true);
            }
        }
    }
}]);
